/*global jQuery, google */
(function($) {
  'use strict';

  window.email = {
    type: 'info'
  };

  var initMap,
      addMarker,
      removeMarker,
      showMarkerTooltip,
      map,
      infowindow,
      gdc,
      directionsDisplay,
      directionsService,
      calcRoute;

  addMarker = function(place, onClick) {

    var marker = new google.maps.Marker({
      position: place.position,
      map: map
    });

    google.maps.event.addListener(marker, 'click', function() {
      onClick.apply(place, [marker]);
    });

    place.marker = marker;
  };

  removeMarker = function(place) {
    if (place.marker) {
      place.marker.setMap(null);
      place.marker = null;
    }

  };

  showMarkerTooltip = function(place) {
    infowindow.setContent(place.tooltip);
    infowindow.open(map, place.marker);
  };

  initMap = function(mapContainer) {

    var tooltip = $('.testo_contatti').html();

    gdc = {
      position: new google.maps.LatLng(
          45.6079965,
          9.3687049
      ),
      tooltip: tooltip
    };

    map = new google.maps.Map(mapContainer, {
      zoom: 16,
      center: gdc.position,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });
    directionsDisplay = new google.maps.DirectionsRenderer();
    directionsDisplay.setMap(map);
    directionsService = new google.maps.DirectionsService();

    infowindow = new google.maps.InfoWindow();

    addMarker(gdc, function() {
      showMarkerTooltip(gdc);
    });

  };

  calcRoute = function(start) {
    var request = {
      origin: start,
      destination: gdc.position,
      travelMode: google.maps.TravelMode.DRIVING
    };
    removeMarker(gdc);
    directionsService.route(request, function(response, status) {
      if (status === google.maps.DirectionsStatus.OK) {
        directionsDisplay.setDirections(response);
      }
    });
  };

  $(function() {

    //var $iconeAereo = $('.ico_aereo, .ico_treno');

    if ($('#map').length > 0) {
      initMap($('#map').get(0));
    }
    /*
    $iconeAereo.on('click', function() {
      $iconeAereo.removeClass('active');
      $(this).addClass('active');
      $('#' + this.id + 'Info').show().siblings().hide();
    });
    
    $('#daMilanoCentrale').click(function() {
      calcRoute('Milano, stazione centrale');
      return false;
    });

    $('#daOrio').click(function() {
      calcRoute('aereoporto Orio al Serio');
      return false;
    });

    $('#daMalpensa').click(function() {
      calcRoute('aeroporto Malpensa');
      return false;
    }).click();

    $('#daLinate').click(function() {
      calcRoute('aeroporto Linate');
      return false;
    });
    */

  });

}(jQuery));
